import React, { useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { ViewContext } from "./contexts/ViewContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function Header({ title }) {
    const { view, dispatch } = useContext(ViewContext);

    return (
        <AppBar position="fixed" color="default">
            <Toolbar>
                <Typography variant="h6" noWrap>
                    {title}
                </Typography>
                <div style={{ flexGrow: 1 }} />
                <div style={{ display: "flex" }}>
                    {view.pageNo > 0 && (
                        <IconButton
                            color="inherit"
                            aria-label="previous page"
                            onClick={() =>
                                dispatch({ type: "CHANGE PAGE", direction: -1 })
                            }
                            edge="end"
                        >
                            <ArrowBackIcon />
                        </IconButton>
                    )}
                </div>
            </Toolbar>
        </AppBar>
    );
}
